import React from 'react';

import Breed from 'services/Breed';
import Country from 'services/Country';

import AbstractForm from 'components/AbstractForm';
import Autocomplete from 'components/autocomplete';
import AutocompleteAsync from 'components/AutocompleteAsync';
import DatePickerInput from 'components/DatePickerInput';

export default class DogForm extends AbstractForm {

  constructor(props) {
    super(props);
    this.state.fathers = [];
    this.state.mothers = [];
    this.state.countries = [];
    this.state.breeds = [];
    this.maxDate = new Date();
    this.idPrefix = props.idPrefix || 'dog';
  }

  getFormData() {
    this.maxDate.setMonth(this.maxDate.getMonth() - 1);
    
    Breed.query().then(({items: breeds}) => {
      if (this.mounted) {
        this.setState( { breeds } );
      }
    });
    Country.query().then(({items: countries}) => {
      if (this.mounted) {
        this.setState( { countries } );
      }
    });
  }

  renderFields() {
    const { item } = this.state;
    return [
        <div className="row" key="row-1">
          
          <div className="col-md-9 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_breed_id"}>Порода</label>
            <Autocomplete items={this.state.breeds} name="breed_id" value={item.breed_id} 
            valueProp="id" labelProp="name" onChange={this.propertyChanged} />
          </div>

          <div className="col-md-3 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_name"}>Пол</label>
            <div className="">
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="sex" id={this.idPrefix+"_sexMale"} value="male" 
                  checked={item.sex === 'male'} onChange={this.propertyChanged} />
                <label className="form-check-label" htmlFor={this.idPrefix+"_sexMale"}>Кобель</label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="sex" id={this.idPrefix+"_sexFemale"} value="female"
                  checked={item.sex === 'female'}  onChange={this.propertyChanged} />
                <label className="form-check-label" htmlFor={this.idPrefix+"_sexFemale"}>Сука</label>
              </div>
            </div>
          </div>

        </div>
      ,
        <div className="row" key="name-pedigree">
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_name"}>Кличка</label>
            <AutocompleteAsync 
              modelName="dog" name="name" value={item.name} 
              onChange={this.propertyChanged} />
          </div>
        
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_pedigree"}>Родословная</label>
            <AutocompleteAsync 
              modelName="dog" name="pedigree" value={item.pedigree} 
              onChange={this.propertyChanged} />
          </div>
        </div>
      ,        
        <div className="row" key="date_of_birth-color">
          <div className="col-md-3 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_date_of_birth"}>Дата рождения</label>
            <div>
              <DatePickerInput
                selected={item.date_of_birth}
                maxDate={this.maxDate}
                name="date_of_birth"
                onChange={this.propertyChanged}
                disabled={!item.breed_id}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_color"}>Окрас</label>
            <AutocompleteAsync modelName="dog" name="color" 
              value={item.color} 
              onChange={this.propertyChanged} disabled={!item.breed_id} />
          </div>
          <div className="col-md-5 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_country_id"}>Страна</label>
            <Autocomplete 
              name="country_id" 
              items={this.state.countries} 
              valueProp="id" labelProp="title" 
              value={item.country_id} 
              onChange={this.propertyChanged}
              disabled={!item.breed_id} />
          </div>
        </div>
      ,
        <div className="row" key="father">
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_father_name"}>Отец</label>
            <AutocompleteAsync 
              modelName="dog" name="father_name" value={item.father_name} 
              onChange={this.propertyChanged}
              disabled={!item.breed_id} />
          </div>
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_mother_name"}>Мать</label>
            <AutocompleteAsync 
              modelName="dog" name="mother_name" value={item.mother_name} 
              onChange={this.propertyChanged}
              disabled={!item.breed_id}  />
          </div>
        </div>
      ,   
        <div className="row" key="titles">
          <div className="col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_titles"}>Титулы</label>
            <AutocompleteAsync 
              modelName="dog" name="titles" value={item.titles} 
              onChange={this.propertyChanged}
              disabled={!item.breed_id}  />
          </div>
        </div>
      ,
        <div className="row" key="owner">
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_owner_name"}>Владелец</label>
            <AutocompleteAsync 
              modelName="dog" name="owner_name" value={item.owner_name} 
              onChange={this.propertyChanged}
              disabled={!item.breed_id} />
          </div>
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_breeder_name"}>Заводчик</label>
            <AutocompleteAsync 
              modelName="dog" name="breeder_name" value={item.breeder_name} 
              onChange={this.propertyChanged}
              disabled={!item.breed_id} />
          </div>
        </div>
      ,
        <div className="row" key="breeder">
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_owner_email"}>E-mail</label>
            <input type="text" className="form-control" id={this.idPrefix+"_owner_email"} name="owner_email" 
              value={item.owner_email} onChange={this.propertyChanged} />
          </div>
          <div className="col-md-6 col-sm-12 mb-3">
            <label htmlFor={this.idPrefix+"_owner_email"}>Телефон(ы)</label>
            <input type="text" className="form-control" id={this.idPrefix+"_owner_phone"} name="owner_phone" 
              value={item.owner_phone} onChange={this.propertyChanged} />
          </div>
        </div>
      ,
        
        <div className="row" key="catalog_options">
          <label htmlFor="need_catalog">
            <input className="m-1" type="checkbox" name="need_catalog" id="need_catalog"
            checked={item.need_catalog} onChange={this.propertyChanged} />
            <b className="me-2">Нужен каталог</b>
          </label>
          <label htmlFor="dont_send_confirmation">
            <input className="m-1" type="checkbox" name="dont_send_confirmation" id="dont_send_confirmation"
            checked={item.dont_send_confirmation} onChange={this.propertyChanged} />
            <b className="me-2">Не высылать подтверждение регистрации</b>
          </label>
        </div>
      ,
        this.props.children
    ];
  }

}